 $(document).ready(function(){
    $('.get-product').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      prevArrow: $('.left-arrow'),
      nextArrow: $('.right-arrow'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.get-product-2').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      prevArrow: $('.left-arrow-1'),
      nextArrow: $('.right-arrow-1'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.get-product-3').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      prevArrow: $('.left-arrow-2'),
      nextArrow: $('.right-arrow-2'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.get-product-4').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      prevArrow: $('.left-arrow-3'),
      nextArrow: $('.right-arrow-3'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.review-main').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      prevArrow: $('.next'),
      nextArrow: $('.preview'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
 
  //   $(".main-get-product .shop-now-btn").on("click", function (e) {
  //   e.preventDefault();

  //   var href = $(this).attr("href");
  //   var productHandle = href.split("/products/")[1];

  //   // Step 1: Get product JSON
  //   $.getJSON("/products/" + productHandle + ".js", function (product) {
  //     var variantId = product.variants[0].id;

  //     // Step 2: Add to cart
  //     $.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: {
  //         id: variantId,
  //         quantity: 1
  //       },
  //       dataType: "json",
  //       success: function (data) {
  //         // Redirect to cart page after adding
  //         window.location.href = "/cart";
  //       },
  //       error: function (err) {
  //         console.error("Error adding to cart:", err);
  //         alert("Something went wrong while adding the product.");
  //       }
  //     });
  //   });
  // });
  });